import {RequestState} from "modules/enums";
import type {TStore} from "modules/types/store";
import {createSelector} from "reselect";
import {find} from "lodash-es";

export const getLeaderboardsStore = (store: TStore) => store.leaderboards;

export const getLeaderboard = createSelector([getLeaderboardsStore], (store) => {
	return store.ladder;
});

export const getLastLeaderboardPayload = createSelector([getLeaderboardsStore], (store) => {
	return store.lastPayload;
});

export const getIsLoadedLeaderboards = createSelector(
	[getLeaderboardsStore],
	(store) => store.requestState === RequestState.RECEIVED
);

export const getFetchedLeaderboardPages = createSelector(
	[getLeaderboardsStore],
	(store) => store.fetchedPages
);

export const getLeaderboardUserByUserId = createSelector(
	[getLeaderboard],
	(ladder) => (userId: number) => {
		return find([...ladder.ranks, ladder.user], {
			userId,
		});
	}
);

export const getProfileByUserId = createSelector(
	[getLeaderboardsStore],
	(store) => (userId: number) => {
		return store.profiles[userId];
	}
);

export const isProfileRequested = createSelector(
	[getLeaderboardsStore],
	(store) => store.profileRequestState === RequestState.REQUESTED
);

export const isVisibleNotice = createSelector(
	[getLeaderboardsStore],
	(store) => store.isVisibleUpdateNotice
);
